import { useEffect } from "react";
import React from "react";


export default function useTimer() {
  const [secondsLeft, setSecondsLeft] = React.useState(-1);

  useEffect(() => {
    if (secondsLeft <= 0) return;

    const timeout = setInterval(() => {
      setSecondsLeft((prev) => prev - 1);
    }
    , 1000);
    
    return () => clearInterval(timeout);
  }, [secondsLeft]);

  const startTimer = (seconds: number) => {
    setSecondsLeft(seconds);
  };

  return { secondsLeft, startTimer };
}


